import {Component, inject, OnInit} from '@angular/core';
import {ToastrService} from 'ngx-toastr';
import {NgSelectModule} from '@ng-select/ng-select';
import {Router, RouterOutlet} from '@angular/router';
import {Subject, takeUntil} from 'rxjs';
import {EventsService} from './shared/services/events.service';
import {AuthService} from './shared/services/auth.service';
import { WsService } from './shared/services/ws.service';

@Component({
  selector: 'app-root',
  imports: [NgSelectModule, RouterOutlet],
  templateUrl: './app.component.html',
  standalone: true,
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  testList: any[] = [
    {name: 'Название 1', value: '1'},
    {name: 'Название 2', value: '2'},
    {name: 'Название 3', value: '3'}
  ]

  private eventsService = inject(EventsService);
  private toastrService = inject(ToastrService);
  private destroy$ = new Subject();

  private router = inject(Router)

  private authService = inject(AuthService);
  private wsService = inject(WsService);

  IsWSconnected = this.wsService.isConnected;

  ngOnInit(): void {
  }

  constructor() {
    this.InitToastr();
    this.AuthCheck();
  }

  AuthCheck(){
    if(this.authService.HasTokens()){
      this.authService.GetMe().subscribe();
    } else{
      this.authService.CLearSession();
      if (!window.location.href.includes('/auth')) {
        this.router.navigate(['/auth']);
      }
    }
  }

  InitToastr() {
    this.eventsService.IsErrorChange$
      .pipe(
        takeUntil(this.destroy$)
      )
      .subscribe((res) => {
        if (res && this.eventsService.Error.status) {
          this.toastrService.error(
            `
            <div class="toast-title">Ошибка системы.</div>
            <div class="toast-text">${this.eventsService.Error.text}</div>
            `,
            '',
            {
              positionClass: "toast-bottom-center",
              enableHtml: true,
              closeButton: true,
            });
        } else {
          this.toastrService.clear();
        }
      })

    this.eventsService.IsSuccessChange$
      .pipe(
        takeUntil(this.destroy$)
      )
      .subscribe((res) => {
        if (res && this.eventsService.Success.status) {
          this.toastrService.success(
            `
            <div class="toast-title">Операция выполнена успешно.</div>
            <div class="toast-text">${this.eventsService.Success.text}</div>
            `,
            '',
            {
              positionClass: "toast-bottom-center",
              enableHtml: true,
              closeButton: true,
            }
          );
        } else {
          this.toastrService.clear();
        }
      })

    this.eventsService.IsProccessingChange$
      .pipe(
        takeUntil(this.destroy$)
      )
      .subscribe((res) => {
        if (res && this.eventsService.Proccessing.status) {
          this.toastrService.info(
            `
            <div class="toast-title">Информация</div>
            <div class="toast-text">${this.eventsService.Proccessing.text}</div>
            `,
            '',
            {
              positionClass: "toast-bottom-center",
              enableHtml: true,
              closeButton: true,
            }
          );
        } else {
          this.toastrService.clear();
        }
      })
  }

  EventClick(type?: string) {
    if (type === 'success') {
      this.eventsService.success('Изменения успешно сохранены');
    } else if (type === 'error') {
      this.eventsService.throwError();
    } else {
      this.eventsService.proccessing('Текст, который нужно знать юзеру');
    }
  }

  DestroyToken() {

  }
}
